<div class="cart-product-total">
  <!-- Sous Total-->
  @if (showSubTotal) {
    <div class="cart-product-total flex-row justify-evenly align-stretch gap-10"
      >
      <!-- Name-->
      <div>{{ "CART.SUB_TOTAL" | transloco }}</div>
      <!-- price && quantity-->
      <div class="flex-1 flex-row justify-end">
        <div>
          <app-price [price]="totalProductPrice"
            [currencyCode]="currencyCode"
          [floating]="false"></app-price>
        </div>
      </div>
    </div>
  }

  <!-- Fees -->
  @for (fee of fees; track trackByFeeIdentity($index, fee)) {
    <div @inOutAnimation
      class="cart-product-total-light flex-row justify-evenly align-stretch gap-10">
      <!-- Name-->
      <div>{{ fee.label }}</div>
      <!-- price && quantity-->
      <div class="flex-1 flex-row justify-end">
        <div>
          <app-price [price]="fee.totalInclTax"
            [currencyCode]="currencyCode"
          [floating]="false"></app-price>
        </div>
      </div>
    </div>
  }

  <!-- Discounts -->
  @for (discount of discounts; track trackByDiscountIdentity($index, discount)) {
    <div @inOutAnimation
      class="cart-product-total-light flex-row justify-evenly align-stretch gap-10">
      <!-- Name-->
      <div>{{ discount.label }}</div>
      <!-- price && quantity-->
      <div class="flex-1 flex-row justify-end">
        <div>
          <app-price [price]="-discount.amount"
            [currencyCode]="currencyCode"
          [floating]="false"></app-price>
        </div>
      </div>
    </div>
  }

  <!--TOTAl HT à retirer: à discuter-->
  @if (withTaxDetails && showVAT) {
    <div
      class="cart-product-total flex-row justify-evenly align-stretch gap-10">
      <!-- Name-->
      <div>Total HT</div>
      <!-- price && quantity-->
      <div class="flex-1 flex-row justify-end">
        <div>
          <app-price [price]="totalExclTaxWithDiscount"
            [currencyCode]="currencyCode"
          [floating]="false"></app-price>
        </div>
      </div>
    </div>
  }

  @if (withTaxDetails && showVAT) {
    <div>
      @for (taxRate of taxRatesBreakdown; track taxRate) {
        <div
          class="cart-product-total-light flex-row justify-evenly align-stretch gap-10">
          <!-- Name-->
          <div>
            {{ "CART.TAXES" | transloco }} {{ taxRate.taxRate * 100 }} {{ "%" }}
          </div>
          <!-- price && quantity-->
          <div class="flex-1 flex-row justify-end">
            <div>
              <app-price [price]="taxRate.totalTax"
                [currencyCode]="currencyCode"
              [floating]="false"></app-price>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Total -->
  <div class="cart-product-total-big-bold flex-row justify-evenly align-stretch gap-10">
    <!-- Name-->
    <div>{{ "CART.TOTAL" | transloco }}</div>

    <!-- price && quantity-->
    <div class="flex-1 flex-row justify-end">
      <div>
        <app-price [price]="totalPrice"
          [currencyCode]="currencyCode"
        [floating]="false"></app-price>
      </div>
    </div>
  </div>

  <!-- Taxes -->
  @if (!withTaxDetails && showVAT) {
    <div
      class="cart-product-total-light flex-row justify-evenly align-stretch gap-10">
      <!-- Name-->
      <div>{{ "CART.TAXES" | transloco }}</div>
      <!-- price && quantity-->
      <div class="flex-1 flex-row justify-end">
        <div>
          <app-price [price]="totalVatPrice"
            [currencyCode]="currencyCode"
          [floating]="false"></app-price>
        </div>
      </div>
    </div>
  }
</div>
